import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useState } from 'react';
import { Spinner } from '@/components/ui/spinner';
import { z } from 'zod';
import { useOAuthCallback } from '@/auth';

const searchSchema = z.object({
  code: z.string().optional(),
  state: z.string().optional(),
  error: z.string().optional(),
  error_description: z.string().optional(),
});

export const Route = createFileRoute('/auth/callback')({
  component: AuthCallback,
  validateSearch: searchSchema,
});

function AuthCallback() {
  const navigate = useNavigate();
  const search = Route.useSearch();
  const [localError, setLocalError] = useState<string | null>(null);

  // Check for OAuth error in URL params
  if (search.error) {
    setLocalError(search.error_description || search.error);
  }

  // Use the OAuth callback hook
  const { error: callbackError } = useOAuthCallback((err) => {
    setLocalError(err);
  });

  const error = localError || callbackError;

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-red-600 mb-4">
            Authentication Error
          </h1>
          <p className="text-gray-600 mb-4">{error}</p>
          <button
            onClick={() => navigate({ to: '/login' })}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            Back to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <Spinner className="h-12 w-12 mx-auto mb-4" />
        <p className="text-gray-600">Completing authentication...</p>
      </div>
    </div>
  );
}
